import { render, staticRenderFns } from "./AlertaZfm.vue?vue&type=template&id=68168508&scoped=true&"
import script from "./AlertaZfm.vue?vue&type=script&lang=js&"
export * from "./AlertaZfm.vue?vue&type=script&lang=js&"
import style0 from "./AlertaZfm.vue?vue&type=style&index=0&id=68168508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68168508",
  null
  
)

export default component.exports